import * as React from 'react';
import './TableHeader.css';

interface Props {
    headers: string[];
    class:
        | 'estimations-product-header'
        | 'current-order-product-header'
        | 'user-orders-header'
        | 'custom-table-header'
        | 'customer-table-header';
}

class TableHeader extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className={this.props.class}>
                {this.props.headers.map((name, i) => (
                    <div key={name + i} className={name.toLowerCase().replace(' ', '-')}>
                        <span>{name}</span>
                    </div>
                ))}
            </div>
        );
    }
}

export default TableHeader;



// WEBPACK FOOTER //
// ./src/view/TableHeader.tsx